<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(selectedInventoryItem.basic.idi)}} Inventory
            <v-spacer/>
            {{displayDocumentIDGTypeA(selectedInventoryItem.basic.tag, selectedInventoryItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <div v-if="this.getDetail !== null && this.getDetail.basic.tag === 'L1'"
              class="mb-3">
                <v-layout row :class="ui.textSubheadingBold">
                  <div class="ml-0">
                    Material Detail
                  </div>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm7>
                    <v-text-field
                    v-model="this.getDetail.basic.title"
                    hint="material name"
                    prepend-icon="category"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                    v-model="this.getDetail.char.dis"
                    hint="discipline"
                    prepend-icon="engineering"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm7>
                    <v-text-field
                    v-model="this.getDetail.char.npart"
                    hint="part number"
                    prepend-icon="pin"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                    v-model="this.getDetail.char.make"
                    hint="vendor"
                    prepend-icon="warehouse"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Material Inventory
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedInventoryItem.basic.title"
                  hint="storage name"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedInventoryItem.basic.id"
                  hint="part id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.type"
                  hint="type"
                  prepend-icon="grid_view"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.crit"
                  hint="crit."
                  prepend-icon="priority_high"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.haz"
                  hint="hazard"
                  prepend-icon="warning"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.owner"
                  hint="owner"
                  prepend-icon="manage_accounts"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedInventoryItem.char.ibound"
                  prepend-icon="login"
                  hint="inbound"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedInventoryItem.char.obound"
                  prepend-icon="logout"
                  hint="outbound"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.stomin"
                  prepend-icon="archive"
                  hint="min"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.stomax"
                  prepend-icon="unarchive"
                  hint="max"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.stoord"
                  prepend-icon="shopping_bag"
                  hint="on order"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="selectedInventoryItem.char.stocur"
                  prepend-icon="inventory_2"
                  hint="available"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="selectedInventoryItem.char.spons"
                  prepend-icon="manage_accounts"
                  hint="ownership"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2 mb-4">
                <v-flex xs12>
                  <v-text-field
                  v-model="selectedInventoryItem.char.com"
                  prepend-icon="local_shipping"
                  hint="current stock change comment"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <InfoDateAgoName :data="this.inventory.stats"/>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="selectedInventoryItem.char.des"
                  :disabled="false"
                  :outline="true"
                  required
                  hint="inventory description"
                  auto-grow
                  persistent-hint
                  readonly
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import master from "@/data/forms/mixins/master.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
export default {
  // eslint-disable-next-line
  mixins: [
    master,
    dateFunctions,
    apptheme,
    numberFunctions,
    financeFunctions,
    displayFunctions
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    ...mapGetters(["getInventoryList", "getDetail", "getCurrentPage"]),
    // selected task item
    selectedInventoryItem() {
      return this.inventory;
    }
  },
  props: {
    inventory: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
